import gql from 'graphql-tag';

export const getConfig = gql`
  query getConfig($config: GetConfigRequest!) {
    getConfig(config: $config) {
      config
    }
  }
`;
